import "./__label.scss"; import "./index.js"
